/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-max-props-per-line */
import PropTypes from 'prop-types';
import React from 'react';

export const TooltipComponent = (props) => {
    const {className, content, id, visible} = props;

    React.useEffect(() => {
        const {eventListeners} = props;
        if (eventListeners) {
            eventListeners.forEach((e) => {
                const element = document.getElementById(e.eventElementId);
                if (element) {
                    element.addEventListener(e.eventName, (ev) => e.fnc(ev));
                }
            });
            return () => {
                eventListeners.forEach((e) => {
                    const element = document.getElementById(e.eventElementId);
                    if (element) {
                        element.removeEventListener(e.eventName, (ev) => e.fnc(ev));
                    }
                });
            };
        }
    }, []);
    return (
        <div
            key={id}
            id={id}
            className={!!visible ? `${className} tooltip-component tooltip-component-active` : `${className} tooltip-component`}
            role='tooltip'
        >
            {content}
        </div>
    );
};

TooltipComponent.defaultProps = {
    className: '',
    visible: false,
    content: '',
};

TooltipComponent.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    visible: PropTypes.bool,
    content: PropTypes.string,
};

export default TooltipComponent;
